import React, { useState, useEffect, useContext } from 'react';
import { getData } from '../../../../common/utils/router';
import { svgSprite } from '../../../../hybrid/wrappers';
import parse from 'html-react-parser';
import UserContext from '../../../../common/utils/getContext';
import Loader from '../../../../widgets/plug/Loader/Loader';
import css from './Question.module.scss';
import classnames from 'classnames';
import T from '../../../../common/components/T';

const Question = ({ item, onClick, isMobile, isActive }) => {
    const [answer, setAnswer] = useState(item?.answer);

    const { userToken, lang } = useContext(UserContext);

    useEffect(() => {
        if (!answer?.text) {
            (async () => {
                const resAnswer = await getData(`/api/v1/faq/questions/${item.id}`, userToken, lang);
                setAnswer(resAnswer?.data?.answer);
            })();
        }
    }, [answer?.text, item.id, lang, userToken]);

    const toggleQuestion = () => {
        onClick(item.id);
    };

    return (
        <div className={css.faqQuestion}>
            <div
                className={classnames(css.wrapTitleBlock, isActive ? css.wrapTitleBlockOpened : null)}
                onClick={!isMobile ? toggleQuestion : () => onClick(item.id)}
            >
                {item.text}
                <div className={!isActive ? css.faqQuestionArrowWrap : classnames(css.faqQuestionArrowWrap, css.rotationArrow)}>
                    {svgSprite(!isActive ? 'plus' : 'menu-minus', {
                        style: {
                            height: '20px',
                            width: '20px',
                            fill: 'var(--Gold-Button-Normal, #B18A4B)'
                        }
                    })}
                </div>
            </div>

            {isActive && (
                <div
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                    className={classnames(css.faqAnswer, css.ckeditorInner)}
                >
                    {!answer ? (
                        <Loader />
                    ) : answer?.text ? (
                        parse(answer?.text)
                    ) : (
                        <T textName='faqPage-no-answer' defaultStr='Нет ответа' page='/faq' />
                    )}
                </div>
            )}
        </div>
    );
};
export default Question;
